<script setup lang="ts">
import { IRouterInfo } from '@/coreDomainsModule/entities/routerInfo';
import { i18n } from '@/i18n';
import { useRoute } from 'vue-router';
import { isEqualRouterInfo } from '../domains/routerInfo';

const t = i18n.t;

// props
const props = defineProps<{
  tabInfoObject: IRouterInfo[];
}>();

const route = useRoute();

/**
 * RouterLinkのクラスをチェックする
 * @param info - Path情報
 */
const routerLinkClass = (info: IRouterInfo) =>
  isEqualRouterInfo(route, info) || (info.router === '/customer' && route.path.startsWith('/customer/FR'))
    ? 'tab__item--active'
    : 'tab__item--inactive';
</script>
<template>
  <div class="tab__container">
    <template v-for="(info, index) in tabInfoObject" :key="index">
      <RouterLink class="tab__item" :class="routerLinkClass(info)" :to="info.router">
        <div>{{ t(info.label) }}</div>
      </RouterLink>
    </template>
  </div>
</template>
<style lang="scss" scoped>
.tab {
  &__container {
    display: grid;
    grid-auto-flow: column;
    justify-content: start;
    align-items: center;
    gap: 16px;
  }

  &__item {
    height: 30px;
    font: Noto Sans JP;
    font-size: 14px;
    line-height: 14px;
    letter-spacing: 0;
    white-space: nowrap;
    text-align: center;
    padding: 8px 0px;

    &--active {
      font-weight: 700;
      color: $textDefault;
      border-bottom: 2px solid $semanticPrimary;
      &:hover {
        color: $textDefault;
      }
    }

    &--inactive {
      font-weight: 400;
      color: $textSecondary;
      &:hover {
        color: $textSecondary;
      }
    }
  }
}
</style>
